function setupEasysizeProxy() {
  var real = document.getElementById('easysize_button');
  var proxy = document.querySelector('[data-quiz-trigger]');
  var sep = document.querySelector('[data-quiz-sep]');
  if (real && proxy) {
    var text = real.textContent.trim();
    if (text) {
      proxy.textContent = text;
      proxy.hidden = false;
      if (sep) sep.hidden = false;
      return true;
    }
  }
  return false;
}

if (!setupEasysizeProxy()) {
  var easysizeObserver = new MutationObserver(function () {
    if (setupEasysizeProxy()) easysizeObserver.disconnect();
  });
  easysizeObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
}

document.addEventListener('click', function (e) {
  if (e.target.closest('[data-quiz-trigger]')) {
    e.preventDefault();
    var real = document.getElementById('easysize_button');
    if (real) real.click();
  }
});